import { AxiosPromise } from 'axios'
import client from '@/shared/apis/client'
import { GuidanceSupportData } from '@/apps/legacy/features/guidance/types/guidanceTypes'

// 服薬指導支援情報 GET. 存在しない場合は back 側で row 作成 + LLM 生成 trigger + 即 processing 応答.
// 4 状態すべて HTTP 200 で返り、 status field で discriminate する.
// version mismatch (= 過去 V3 で生成済を V2 user が開く) のみ HTTP 409 で axios error.
export const getGuidanceSupportData = (
  yakurekiId: string
): AxiosPromise<GuidanceApiResponse> => {
  return client.get(`/api/guidance/${yakurekiId}/`)
}

export const saveSelectedScripts = (
  yakurekiId: string,
  scriptSelections: Record<string, boolean>,
  scriptOrder: string[]
): AxiosPromise<CompletedResponse> => {
  return client.patch(`/api/guidance/${yakurekiId}/`, {
    scriptSelections,
    scriptOrder,
  })
}

export interface ProcessingResponse {
  status: 'processing'
  estimatedSeconds?: number
}

export interface CompletedResponse {
  status: 'completed'
  data: {
    version: 'v2'
    requestId: string
    scriptData: GuidanceSupportData['scriptData']
    detailData: GuidanceSupportData['detailData']
  }
}

export interface FailedResponse {
  status: 'failed'
  error: {
    message: string
    code: string
  }
}

export interface SkippedResponse {
  status: 'skipped'
  reason?: string
  message?: string
}

export type GuidanceApiResponse =
  | ProcessingResponse
  | CompletedResponse
  | FailedResponse
  | SkippedResponse

export const isProcessingResponse = (
  response: unknown
): response is ProcessingResponse =>
  typeof response === 'object' &&
  response !== null &&
  'status' in response &&
  (response as { status: string }).status === 'processing'

export const isCompletedResponse = (
  response: unknown
): response is CompletedResponse =>
  typeof response === 'object' &&
  response !== null &&
  'status' in response &&
  (response as { status: string }).status === 'completed'

export const isFailedResponse = (
  response: unknown
): response is FailedResponse =>
  typeof response === 'object' &&
  response !== null &&
  'status' in response &&
  (response as { status: string }).status === 'failed'

export const isSkippedResponse = (
  response: unknown
): response is SkippedResponse =>
  typeof response === 'object' &&
  response !== null &&
  'status' in response &&
  (response as { status: string }).status === 'skipped'
